import React, { useState, useEffect } from "react";
import quickSightAxiosCall from '../../components/axiosComponent/quickSightAxiosCall'

const QuickSightEmbedding = require("amazon-quicksight-embedding-sdk");

function QuicksightDashboard(props) {
  const [callonece, setCallonece] = React.useState(0);
  const [noLoader, setNoLoader] = React.useState(false);
  const [dashboardRef, setDashboardRef] = React.useState(React.createRef());

  useEffect(() => {
    getQuickSightUrl();
  }, [props.dashboardToLoad]);

  const getQuickSightUrl = () => {
    let element = document.getElementById('embeddingContainer');
    if (element.firstChild) {
      element.removeChild(element.firstChild);
    }

    let dashboardURL = props.dashboardToLoad;
    if (callonece <= 1 && props?.dashboardToLoad) {
      quickSightAxiosCall({
        url: "/aws/dashboard",
        method: "post",
        Items: { dashboard_id: dashboardURL }
      })
        .then((response) => {
          setCallonece(2)
          embedDashboard(response.data.data)
        })
        .catch(
          (error) => {
            if (error?.data?.data) {
              embedDashboard(error.data.data)
            }
          })
    }
  }

  const embedDashboard = (url) => {
    console.log(url)
    //var containerDiv = document.getElementById("embeddingContainer");

    var options = {
      url: url,
      container: dashboardRef.current,
      scrolling: "no",
      height: "900px",
      width: "100%",
      footerPaddingEnabled: true,
      printEnabled: true,
    };
    let dashboard = QuickSightEmbedding.embedDashboard(options);
    setNoLoader(true)
  }

  return (
    <>
      <div ref={dashboardRef} id="embeddingContainer"></div>
      {noLoader ?
        null :
        <>
          <div className="spinner-loader-quicksight">

            <div className="spinner-grow text-primary" role="status">
              <span className="sr-only">Loading...</span>
            </div>
            <div className="spinner-grow text-secondary" role="status">
              <span className="sr-only">Loading...</span>
            </div>
            <div className="spinner-grow text-success" role="status">
              <span className="sr-only">Loading...</span>
            </div>
            <div className="spinner-grow text-danger" role="status">
              <span className="sr-only">Loading...</span>
            </div>
            <div className="spinner-grow text-warning" role="status">
              <span className="sr-only">Loading...</span>
            </div>
            <div className="spinner-grow text-info" role="status">
              <span className="sr-only">Loading...</span>
            </div>
            <div className="spinner-grow text-light" role="status">
              <span className="sr-only">Loading...</span>
            </div>
            <div className="spinner-grow text-dark" role="status">
              <span className="sr-only">Loading...</span>
            </div>
          </div>
        </>
      }
    </>
  );
}

export default QuicksightDashboard;
